module.exports = __webpack_public_path__ + "static/img/solution-content3.d38ce81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution-content3.png
// module id = 1qHa
// module chunks = 0